import { render, staticRenderFns } from "./common-mobilephone-without-zero-order.vue?vue&type=template&id=e5e72f8c"
import script from "./common-mobilephone-without-zero-order.vue?vue&type=script&lang=js"
export * from "./common-mobilephone-without-zero-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports